import { SvgProps } from "../../types";

const Meter1 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#34C759"}
      fillRule="evenodd"
      d="M18.175.283H2.62A2.222 2.222 0 0 0 .397 2.505v15.556a2.222 2.222 0 0 0 2.223 2.222h15.555a2.223 2.223 0 0 0 2.223-2.222V2.505A2.222 2.222 0 0 0 18.175.283Zm-10 17.778a1.111 1.111 0 1 1 0-2.222 1.111 1.111 0 0 1 0 2.222Zm4.445 0a1.11 1.11 0 1 1 0-2.222 1.11 1.11 0 0 1 0 2.222Zm4.444 0a1.111 1.111 0 1 1 0-2.222 1.111 1.111 0 0 1 0 2.222Zm1.111-4.445H2.62V2.506h15.555v11.11ZM15.953 6.95h-5.555V4.727h5.555V6.95Zm0 4.444H7.064V9.172h8.889v2.222Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Meter1;
